import { MapPin, ChevronRight, ArrowDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
const heroImg = '/images/hero-building.webp';

const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[90vh] flex items-center pt-20 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src={heroImg}
          alt="Modern modular container building in a desert landscape at golden hour"
          className="w-full h-full object-cover scale-105 animate-[slowZoom_20s_ease-in-out_infinite_alternate]"
          loading="eager"
          fetchPriority="high"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground/90 via-foreground/75 to-foreground/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground/60 via-transparent to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full">
        <div className="max-w-2xl">
          <p className="text-sm font-medium tracking-[0.25em] uppercase mb-5 text-primary opacity-0 animate-[fadeSlideUp_0.6s_ease-out_0.2s_forwards]">
            {t('hero.company')}
          </p>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] mb-6 text-background opacity-0 animate-[fadeSlideUp_0.7s_ease-out_0.4s_forwards]">
            {t('hero.title')} <span className="text-primary">{t('hero.titleHighlight')}</span>
          </h1>
          <p className="text-lg leading-relaxed mb-6 text-background/80 max-w-xl opacity-0 animate-[fadeSlideUp_0.7s_ease-out_0.6s_forwards]">
            {t('hero.desc')}
          </p>
          <div className="flex items-center gap-2 mb-8 opacity-0 animate-[fadeSlideUp_0.6s_ease-out_0.7s_forwards]">
            <span className="inline-flex items-center gap-1.5 text-sm bg-background/10 backdrop-blur-sm px-3 py-1.5 rounded-full text-background/80 border border-background/20">
              <MapPin size={14} />
              {t('hero.location')}
            </span>
          </div>
          <div className="flex flex-wrap gap-4 opacity-0 animate-[fadeSlideUp_0.6s_ease-out_0.8s_forwards]">
            <a href="#solutions">
              <Button className="bg-primary text-primary-foreground hover:bg-primary/90 px-7 py-3 text-sm gap-2 transition-transform duration-200 hover:scale-105">
                {t('hero.exploreSolutions')} <ChevronRight size={16} />
              </Button>
            </a>
            <a href="#contact">
              <Button variant="ghost" className="border border-background/40 text-background hover:bg-background hover:text-foreground px-7 py-3 text-sm transition-all duration-300">
                {t('hero.contactUs')}
              </Button>
            </a>
          </div>
        </div>

        <a
          href="#solutions"
          className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce text-background/50 hover:text-background transition-colors duration-300"
          aria-label="Scroll down"
        >
          <ArrowDown size={28} />
        </a>
      </div>
    </section>
  );
};

export default HeroSection;
